export default function createActionEnhancerMiddleware(_getEnhancers) {
  if (typeof _getEnhancers !== 'function') {
    _getEnhancers = function getEnhancers() {
      return _getEnhancers;
    };
  }

  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        var state = getState();
        var enhancedFields = {};

        _getEnhancers(state).forEach(function (enhancer) {
          if (enhancer.id && action[enhancer.id] !== undefined) {
            Object.assign(enhancedFields, enhancer.mapState(state, action[enhancer.id]));
          } //no need to check if actionType is defined since type is required anyway
          else if (enhancer.actionTypes && enhancer.actionTypes.indexOf(action.type) > -1) {
              Object.assign(enhancedFields, enhancer.mapState(state));
            }
        });

        return next(Object.assign(enhancedFields, action));
      };
    };
  };
}
export function isEnhancerById(e) {
  return Object.prototype.hasOwnProperty.call(e, 'id');
}
export function isEnhancerByType(e) {
  return Object.prototype.hasOwnProperty.call(e, 'actionTypes');
}